<template>
  <div class="row">
    <div
      class="col-12 q-mb-md"
      v-html="direction.content"
    />
    <div
      v-for="item in direction.children"
      :key="item.name"
      class="col-6 col-sm-4 col-md-3"
    >
      <router-link
        class="city fs-14 link"
        :to="`/${$route.params.locale}/directions/${item.cache_path}`"
      >
        {{ item.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Country',
  preFetch({ currentRoute, store, ssrContext }) {
    return store.dispatch('directions/fetchDirection', currentRoute.path.replace(/.*\/directions\//, ''))
      .then(() => {
        if (ssrContext && !store.state.directions.direction) {
          return Promise.reject({ code: 404 });
        }

        return undefined;
      });
  },
  computed: {
    ...mapGetters('directions', ['direction']),
  },
};
</script>
